// extracted by mini-css-extract-plugin
export var cost = "cost-module--cost--9b9a3";
export var cost__blockBtn = "cost-module--cost__block-btn--7d61c";
export var cost__btn = "cost-module--cost__btn--74fd0";
export var cost__col = "cost-module--cost__col--a78ed";
export var cost__heading = "cost-module--cost__heading--8474d";
export var cost__headingOtl = "cost-module--cost__heading--otl--769b2";
export var cost__headingTeach = "cost-module--cost__heading--teach--17995";
export var cost__info = "cost-module--cost__info--3d578";
export var cost__item = "cost-module--cost__item--be15d";
export var cost__list = "cost-module--cost__list--f66ac";
export var cost__price = "cost-module--cost__price--fc62f";
export var cost__priceColor = "cost-module--cost__price-color--fc01e";
export var cost__priceOtl = "cost-module--cost__price--otl--0801f";
export var cost__priceSub = "cost-module--cost__price--sub--b04da";
export var cost__priceTeach = "cost-module--cost__price--teach--ff1bf";
export var cost__priceText = "cost-module--cost__price-text--ec98b";
export var cost__priceWrapper = "cost-module--cost__price-wrapper--e6a54";
export var cost__row = "cost-module--cost__row--5fce6";
export var cost__sub = "cost-module--cost__sub--21b9b";
export var cost__subBtn = "cost-module--cost__sub-btn--c2e55";
export var cost__title = "cost-module--cost__title--7b3dc";
export var cost__undertext = "cost-module--cost__undertext--42402";
export var cost__wrapper = "cost-module--cost__wrapper--5a8a6";
export var monthSmall = "cost-module--month-small--275c2";
export var specialPrice = "cost-module--special-price--6f898";